<template>
    <div>
        <el-drawer :modal="false" 
            :visible.sync="drawerCreateProFormaInvoice"
            class="drawer-invoice-table"
            size="45%"
        >

            <template slot="title">
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="font-weight-600">Create Invoice</h3>
                    <!-- <div class="d-flex align-items-center mx-2">
                        <div class="d-flex align-items-center mx-2 text-primary cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                            <p class="text-xs mx-1 text-primary">Preview</p>
                        </div>
                        <div class="d-flex align-items-center text-primary cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4z"/></svg>
                            <p class="text-xs mx-1 text-primary">Share</p>
                        </div>
                    </div> -->
                </div>
            </template>

            <b-container>
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <b-form role="form" @submit.prevent="submit()">
                        <div class="d-flex justify-content-between">
                            <b-form-group
                                label="Select a Customer"
                                style="width: 200px;"
                            >
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'customerId'"
                                >
                                    <el-select
                                        v-model="customerSelected"
                                        filterable
                                        remote
                                        reserve-keyword
                                        placeholder="Please enter customer"
                                        :remote-method="remoteMethod"
                                        :loading="loading"
                                        value-key="customer_id"
                                        required
                                        >
                                        <el-option
                                            v-for="customer in options"
                                            :key="customer.customer_id"
                                            :label="customer.name"
                                            :value="customer">
                                        </el-option>
                                    </el-select>
                                    <!-- <small class="bg-success w-auto">si Wakak</small> -->
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                            <b-form-group
                                label="Issue Date"
                                style="width: 200px;"
                            >
                                <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'issuedDate'"
                                >
                                    <el-date-picker
                                        type="datetime"
                                        placeholder="Pick a Date"
                                        v-model="invoiceForm.inv_issued_date"
                                        value-format="yyyy-MM-dd hh:mm:ss"
                                        required>
                                    </el-date-picker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </div>

                        <hr class="hr">

                        <h3>Product Details</h3>

                        <div class="table-listings input-table">
                            <b-table-simple bordered class="table-listings input-table">
                                <b-thead>
                                    <b-tr style="border: #252938;">
                                        <b-th width="35%" style="background-color: #252938;" class="text-white">Product Name</b-th>
                                        <b-th style="min-width: 70%; background-color: #252938;" class="text-white">Description</b-th>
                                        <b-th width="25%" style="background-color: #252938;" class="text-white">Amount (RM)</b-th>
                                        <b-th style="background-color: #252938;"></b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr>
                                        <b-td class="p-0 m-0">
                                            <el-input 
                                                placeholder="Product Name"
                                                class="input-table"
                                                v-model="items.item_name"
                                            ></el-input>
                                        </b-td>
                                        <b-td class="p-0 m-0">
                                            <el-input 
                                                placeholder="Description"
                                                class="input-table"
                                                v-model="items.item_description"
                                            ></el-input>
                                        </b-td>
                                        <b-td class="p-0 m-0">
                                            <CurrencyInput
                                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                                class="border-0"
                                                v-model="items.item_amount"
                                            />
                                        </b-td>
                                        <b-td>
                                            <el-button class="m-0 p-0" @click="addRowItem" :disabled="(items.item_description === '' || items.item_name === '')">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="#28A745" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                                            </el-button>
                                        </b-td>
                                    </b-tr>
                                    <b-tr v-for="item in invoiceForm.inv_items" :key="item.id">
                                        <b-td>
                                            <p style="font-size: 13px;">{{ item.itm_tittle }}</p>
                                        </b-td>
                                        <b-td>
                                            <p style="font-size: 13px;">{{ item.itm_description }}</p>
                                        </b-td>
                                        <b-td>
                                            <p style="font-size: 13px;">{{ item.itm_amount }}</p>
                                        </b-td>
                                        <b-td>
                                            <el-button class="m-0 p-0" @click="removeRowItem(item.row_no)">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="#DC3545" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/></svg>
                                            </el-button>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="2" style="border: none;" class="text-right font-weight-700">SubTotal</b-td>
                                        <b-td class="font-weight-700">RM {{ totalAmount | moneyFormatter }}</b-td>
                                    </b-tr>
                                    <b-tr> 
                                        <b-td colspan="2" style="border: none;" class="text-right">Tax</b-td>
                                        <b-td>RM 0.00</b-td>
                                    </b-tr>
                                    <b-tr> 
                                        <b-td colspan="2" style="border-top: none; font-size: 16px;" class="text-right font-weight-600">Total</b-td>
                                        <b-td style="border: none; font-size: 16px;" class="font-weight-600">RM {{ totalAmount | moneyFormatter }}</b-td>
                                        <b-td></b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>

                        <b-form-group
                            label="Remarks"
                        >
                            <el-input type="textarea" rows="4" v-model="invoiceForm.inv_remark">

                            </el-input>
                        </b-form-group>

                        <b-row class="mt-1 pt-4 pb-5 text-center w-100">
                            <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                                <b-button variant="primary" type="submit" class="w-100" :disabled="invalid || checkItems">Create</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
            </b-container>
        </el-drawer>
    </div>
</template>

<script>
    import { Drawer, Button, Select, Option, DatePicker, Table, TableColumn } from 'element-ui'
    import vue2Dropzone, { methods } from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import {axios, services, getHeader, helperFunctionMixin } from '@/assets/js/httpImports.js'
    import CurrencyInput from '@/components/CurrencyInput'
    import { EventBus } from "@/main";
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import '@/assets/js/formValidations.js'

    export default {
        components: {
            CurrencyInput,
            ValidationObserver,
            ValidationProvider,
            vueDropzone: vue2Dropzone,
            [Drawer.name]: Drawer,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        mixins: [notifyFunctionMixin, helperFunctionMixin],
        data() {
            return {
                drawerCreateProFormaInvoice: false,
                loading: false,
                tableData: [],
                productList: [
                    {
                        prod_id:1,
                        prod_name: "Acacia Residences"
                    },
                ],
                invoiceForm: {
                    inv_user_id:null,
                    inv_user_type:null,
                    inv_user_name:null,
                    inv_stm_id:null, //if set will check existing
                    inv_scrb_id:null, //if set will check existing
                    inv_pckg_id:null, //if set will check existing
                    inv_title:null,
                    inv_description:null,
                    inv_ref_no:null, //if null will auto generate
                    inv_issued_date:null,
                    inv_status:null, //DRAFT,ISSUED,PAID,CANCELED
                    inv_remark:null,
                    inv_items: [
                    ],
                },
                items: {
                    item_id:0,
                    item_name: "",
                    item_description: "",
                    item_amount: "",
                    item_total: "",
                    itm_qty: "1",
                },
                customerList:[],
                options: [],
                value: [],
                list: [],
                loading: false,
                customerSelected:null,
            }
        },

        created(){
            this.getCustomers()
        },

        computed: {
            totalAmount() {
                return this.invoiceForm.inv_items.reduce((total, row) => total + row.itm_amount, 0);
            },
            checkItems() {
                if(this.invoiceForm.inv_items.length > 0){
                    return false
                }
                return true
            }
        },

        mounted() {
            this.list = this.customerList
        },

        methods: {
            viewCreateProformaInvoice() {
                this.drawerCreateProFormaInvoice = !this.drawerCreateProFormaInvoice
            },

            submit() {
                this.invoiceForm.inv_user_id = this.customerSelected.customer_id
                this.invoiceForm.inv_user_name = this.customerSelected.name
                this.customerSelected = null
                this.invoiceForm.inv_user_type = "customer"
                this.invoiceForm.inv_status = "ISSUED"
                let formData = this.invoiceForm
                axios.post(services.billing + 'invoice', formData, { headers: getHeader() })
                    .then(res => {
                        this.resetFormToNull(this.invoiceForm)
                        this.resetFormToNull(this.items)
                        this.invoiceForm.inv_items = []
                        this.notifySuccess('<b>Invoice : ' + res.data.inv_ref_no + '</b> - Successfully Created.')
                        this.drawerCreateProFormaInvoice = !this.drawerCreateProFormaInvoice
                        EventBus.$emit('refresh-invoice-list')
                        // this.$router.push('leadProfileDetails/'+res.data.data.lead_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },

            getCustomers() {
                axios.get(services.customer+'customers',
                    {
                        params: {
                            paginate: 100
                        },
                        headers: getHeader()
                    })
                    .then(res => {
                        this.customerList = res.data.data.data
                        this.isTableLoading = false
                    })
                    .catch(e => {
                        this.isTableLoading = false
                        this.errorFunction(e)
                    })
            },

            addRowItem() {
                this.items.item_id += 1
                this.invoiceForm.inv_items.push({
                    row_no: this.items.item_id,
                    itm_tittle: this.items.item_name,
                    itm_description: this.items.item_description,
                    itm_qty:1,
                    itm_amount: this.items.item_amount,
                    itm_total: this.items.item_amount
                })
                this.items.item_name = ''
                this.items.item_description = ''
                this.items.item_amount = ''
            },

            removeRowItem(data) {
                this.invoiceForm.inv_items = this.invoiceForm.inv_items.filter(item => item.row_no !== data)
            },

            remoteMethod(query) {
                if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.customerList.filter(item => {
                        return item.name ? item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 : false;
                    });
                }, 200);
                } else {
                    this.options = [];
                }
            }

        }
    }
</script>
